export const environment = {
  T_SHIRT_CAFE_BE_HOST_PORT: 'https://rr.dev.be.savaapi.com',
  USER_PATH: 'tshirtcafe',
  INS: 'mongodb',
  DB: 't_shirt_cafe',
  authTokenInfo: 't_shirt_cafe_authorization',
  T_SHIRT_CAFE_BE_WS_HOST_PORT: 'wss://rr.dev.ws.savaapi.com',
  IS_ENCRYPTED: false,
  ENV: 'DEV',
  BUCKET_NAME: 'sava-s3',
  FILE_PATH: 't-shirt-cafe-dev',
  FILE_URL: 'https://sava-s3.in-maa-1.linodeobjects.com/',
  RAZORPAY_KEY_ID: '',
  get T_SHIRT_CAFE_BE_HOST_PORT_SITES() { return this.T_SHIRT_CAFE_BE_HOST_PORT + '/api'; }
};
